export default __webpack_public_path__ + "static/media/mindmap_hyperactivite_ou_instabilite.b08c7e77.png";